<template>
  <div class="confirm-item" :class="{'is-em': em, 'is-twoline': quantity.value > 0}">
    <div class="item-label">{{label}}</div>
    <div class="item-quantity">
      <span>{{quantity.value}}</span>
      <small>{{quantity.unit}}</small>
    </div>
    <div class="item-charge">
      <span>{{charge | comma}}</span>
      <small>円</small>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.confirm-item {
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;

  .item-label {
    flex-grow: 1;
  }

  .item-quantity {
    display: none;
  }

  .item-charge {
    width: 5em;
    text-align: right;
  }

  small {
    margin-left: .5em;
    color: $caption-black-text-color;
  }
}

.confirm-item.is-em {
  line-height: 24px;

  .item-label, .item-charge > span {
    font-weight: bold;
  }

  .item-charge > span {
    font-size: 16px;
  }
}

.confirm-item.is-twoline {
  .item-label {
    flex-grow: 0;
    width: 100%;
  }

  .item-quantity {
    display: block;
    margin-left: 2em;
    flex-grow: 1;
  }
}
</style>

<script>
import PartBase from '@/mixins/PartBase'

export default {
  name: 'ConfirmItem',
  mixins: [
    PartBase
  ],
  props: {
    em: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    quantity: {
      type: Object,
      default () {
        return { value: 0, unit: '' }
      }
    },
    charge: {
      type: Number,
      required: true
    }
  }
}
</script>
